import React from 'react';
import { User } from 'lucide-react';

const Header: React.FC = () => {
  return (
    <header className="h-16 bg-white border-b border-slate-200 px-6 flex items-center justify-between">
      <div>
        <h2 className="text-lg font-semibold text-slate-900">Panel de Administración</h2>
        <p className="text-xs text-slate-500">Hotel Chiavari - San Bernardo del Tuyú</p>
      </div>

      <div className="flex items-center gap-4">
        <div className="w-9 h-9 bg-slate-100 rounded-lg flex items-center justify-center">
          <User size={18} className="text-slate-600" />
        </div>
      </div>
    </header>
  );
};

export default Header;
